/**
 * ContentUpdateListener Component
 *
 * Global component that establishes and maintains the WebSocket connection.
 * Individual pages (Contact, ProductListing, etc.) handle their own update logic.
 *
 * This component:
 * - Establishes WebSocket connection on app load
 * - Logs connection status
 * - Individual pages subscribe to specific updates they care about
 */

import { useEffect } from 'react';
import useContentUpdates from '../hooks/useContentUpdates';
import featureFlags from '../utils/featureFlags';

function ContentUpdateListener() {
  useEffect(() => {
    if (featureFlags.useWebSocketUpdates()) {
      console.log('[ContentUpdateListener] WebSocket real-time updates enabled');
    } else {
      console.log('[ContentUpdateListener] WebSocket updates disabled (REACT_APP_ENABLE_WEBSOCKET=false)');
    }
  }, []);

  // Initialize WebSocket connection
  // Individual pages will subscribe to updates via their own useContentUpdates hooks
  useContentUpdates({
    onConnected: () => {
      console.log('[ContentUpdateListener] ✅ WebSocket connected - Real-time updates active');
    },

    onDisconnected: () => {
      console.log('[ContentUpdateListener] ⚠️ WebSocket disconnected - Will auto-reconnect...');
    },

    onError: (error) => {
      console.error('[ContentUpdateListener] ❌ WebSocket error:', error);
    }
  });

  // This component has no UI
  return null;
}

export default ContentUpdateListener;
